// extracted by mini-css-extract-plugin
export default {"titleCon":"TitleSection_titleCon__K53kp","title":"TitleSection_title__tzpmB","subTitle":"TitleSection_subTitle__+zsNm"};